import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import AOS from 'aos';
import 'aos/dist/aos.css';

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';

import {
  MdCorporateFare,
  MdDirectionsCar,
  MdLocalShipping,
  MdMedicalServices,
  MdOutlineCode
} from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";

export default function ServicesBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({ duration: 700, once: true });
  }, []);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center py-5">
        {getInlineLoader()}
      </div>
    );
  }

  const subsidiaries = [
    {
      title: "Ndomano Capital",
      cls: "col-md-6",
      desc: "Investment & microfinance",
      subItem: "Ndomano_Capital",
      image: banner1,
      icon: <MdCorporateFare size={30} />
    },
    {
      title: "Ndomano Motors",
      cls: "col-md-6",
      desc: "Automotive care & parts",
      subItem: "Ndomano_Motors",
      image: banner2,
      icon: <MdDirectionsCar size={30} />
    },
    {
      title: "Ndomano Logistics",
      cls: "col-md-4",
      desc: "Cargo transport & tracking",
      subItem: "Ndomano_Logistics",
      image: banner3,
      icon: <MdLocalShipping size={30} />
    },
    {
      title: "Ndomano Pharmaceuticals",
      cls: "col-md-4",
      desc: "Pharma & nutrition supplies",
      subItem: "Ndomano_Pharmaceuticals",
      image: banner4,
      icon: <MdMedicalServices size={30} />
    },
    {
      title: "Werenium Technologies",
      cls: "col-md-4",
      desc: "Software & automation",
      subItem: "Werenium_Technologies",
      image: banner5,
      icon: <MdOutlineCode size={30} />
    },
  ];

  return (
    <div className="MainBodySection py-5">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-md-9 text-center">
            <h2
              className="font-bold main-section-title"
              style={{ fontSize: "2.4rem", letterSpacing: "-0.5px" }}
            >
              SUBSIDIARIES
            </h2>
            <p
              className="text-muted mt-3"
              style={{ fontSize: "1.1rem", maxWidth: "700px", margin: "0 auto" }}
            >
              Five purpose-built companies — unified by innovation, powered by technology, committed to Africa’s growth.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {subsidiaries.map((svc, idx) => (
            <div key={idx} className={svc.cls} data-aos="fade-up">
              <div
                className="rounded-4 overflow-hidden"
                style={{
                  cursor: "pointer",
                  background: "#fff",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onClick={() =>
                  appContext.navTo({ item: 'subsidiaries', subItem: svc.subItem })
                }
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.06)";
                }}
              >
                {/* Image & Icon */}
                <div className="position-relative" style={{ height: "180px" }}>
                  <img
                    src={svc.image}
                    alt={svc.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />

                  {/* Enlarged Icon */}
                  <div
                    className="position-absolute top-0 start-0 d-flex align-items-center justify-content-center"
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "16px",
                      backgroundColor: "#fff",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                    }}
                  >
                    <span style={{ color: "#00356d" }}>
                      {svc.icon}
                    </span>
                  </div>

                  {/* Gradient overlay */}
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,53,109,0.25) 100%)",
                    }}
                  />
                </div>

                {/* Content */}
                <div className="p-4">
                  <h5
                    className="fw-bold mb-1"
                    style={{ fontSize: "1.25rem", color: "#1a1a1a" }}
                  >
                    {svc.title}
                  </h5>
                  <p className="text-muted mb-3" style={{ fontSize: "0.95rem" }}>
                    {svc.desc}
                  </p>
                  <div
                    className="d-flex align-items-center text-primary fw-semibold"
                    style={{ fontSize: "0.95rem" }}
                  >
                    Learn More
                    <FaArrowRight className="ms-1" size={14} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
